import React, { Component } from 'react';

//<div>Change someone's life.</div>
//<div><b>One meal at a time.</b></div>

class OpeningHeader extends Component {
  render() {
    return (
      <h1 id="OpeningHeader">
        <div>Change lives.</div>
        <div><b>One meal at a time.</b></div>
        <div>Locally, and around the world.</div>
      </h1>
      
    );
  }
}

export default OpeningHeader;
